import script from "./GgmsInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsInput.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsInput.vue?vue&type=style&index=0&id=79ff29ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ff29ec"]])

export default __exports__